import alertify from 'alertifyjs';

import {
    ALERT_SUCCESS,
    ALERT_ERROR,
    ALERT_CLEAR
} from '../../constants/actionTypes';

export const alertActions = {
    success,
    error,
    clear
};

function success(message) {
    clear();
    alertify.success(message);
    return { type: ALERT_SUCCESS, message };
}

function error(message) {
    console.log('alert action = ' + message);
    clear();
    alertify.error(message);
    return { type: ALERT_ERROR, message };
}

function clear() {
    alertify.dismissAll();
    return { type: ALERT_CLEAR };
}
